import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  fill: "white",
  stroke: "white"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.912109 6.98427C0.912109 4.11354 0.912109 2.67818 1.80398 1.78635C2.69586 0.894531 4.13131 0.894531 7.00221 0.894531C9.87311 0.894531 11.3086 0.894531 12.2004 1.78635C13.0923 2.67818 13.0923 4.11354 13.0923 6.98427C13.0923 9.85501 13.0923 11.2904 12.2004 12.1822C11.3086 13.074 9.87311 13.074 7.00221 13.074C4.13131 13.074 2.69586 13.074 1.80398 12.1822C0.912109 11.2904 0.912109 9.85501 0.912109 6.98427Z",
      fill: "none",
      "stroke-width": "1.3"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "8.78777",
      cy: "4.09826",
      rx: "0.961595",
      ry: "0.961538"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.56625 13.3938C9.16909 11.9675 8.24211 10.6901 6.92285 9.7619C5.50037 8.76111 3.71438 8.23141 1.88354 8.26734C1.66615 8.26683 1.44894 8.27377 1.23242 8.2881",
      fill: "none",
      "stroke-width": "1.3",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.64258 10.8289C8.73336 9.97851 9.90841 9.54223 11.0955 9.54691C11.7686 9.54622 12.4385 9.68895 13.0916 9.97104",
      fill: "none",
      "stroke-width": "1.3",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }